import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import { ICON_BASKET } from "../../utils/icons";
import OverallInventory from "../../components/user/inventory/OverallInventory";
import AllInventory from "../../components/user/inventory/AllInventory";

function Inventory() {

  return (
    <>
      <AppWrapper
        pagename={"inventory"}
      >
        <StyledInventory>
          <Title title={"Inventory"} link={"/user/inventory/item"} btnName={"Items"} btnIcon={ICON_BASKET} />
        </StyledInventory>

        <OverallInventory />
        <AllInventory />


      </AppWrapper>

    </>
  );
}

export default Inventory;

const StyledInventory = styled.div`

`;